<template>
  <div class="wt-asset-icons-box">
    <div class="wt-asset-icons">
      <div
        v-for="(icon, i) in icons"
        class="-icon"
        :class="'-' + icon.boxClass"
        :key="i"
      >
        <template v-if="icon.iconClass">
          <i :class="icon.iconClass" />
        </template>
      </div>
      <span>{{ duration }}</span>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  props: {
    icons: {
      type: Array,
      required: true,
    },
    duration: {
      type: String,
      required: true,
    },
  },
});
</script>
